customElements.define("cluster-marker", class extends HTMLElement {

    get src() { return this.getAttribute("src") }
    get width() { return this.getAttribute("width") }
    get height() { return this.getAttribute("height") }

    constructor() {

        super();

    }

});